import { useMutation, useQuery } from "@tanstack/react-query";
import { generateHookExports } from "api/generateExports";
import { createCRUDService } from "api/queryService";
import { formatPayloadIfNeeded } from "api/utils";
import axios from "../axios";
import { API_CONFIG } from "services/apiConfig";
import { showToast } from "services/utils";

let baseData = API_CONFIG.CUSTOMER_SERVICE;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const customerService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
  custom: {
    getBySubId: (id, subId, options = {}) =>
      useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: () =>
          axios.get(`${BASE_URL}/${id}/${subId}`).then((res) => res.data),
        enabled: !!id,
        retry: options.retry ?? 1,
      }),
    createReport: () => {
      return useMutation({
        mutationFn: (payload) => {
          const data = formatPayloadIfNeeded(
            payload,
            payload?.isCustomImage ?? false
          );
          return axios
            .post(`${BASE_URL}/create-report`, data, {
              headers:
                data instanceof FormData
                  ? { "Content-Type": "multipart/form-data" }
                  : {},
            })
            .then((res) => res.data);
        },
        onSuccess: (data) => {
          showToast(data);
        },
        onError: (error) => {
          showToast(error?.data);
        },
      });
    },
    getBmrByIds: (productId, variantId, options = {}) =>
      useQuery({
        queryKey: [QUERY_KEY, productId, variantId],
        queryFn: () =>
          axios
            .post(`${BASE_URL}/get-bmr`, {
              productId,
              variantId,
            })
            .then((res) => {
              return (
                res?.data?.data?.map((item) => ({
                  label: item.bmrNumber,
                  value: item._id,
                  ...item,
                })) || []
              );
            }),
        enabled: !!productId && !!variantId,
        retry: options.retry ?? 1,
    }),
    getTimechartData: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY, 'getTimechartData', params],
        queryFn: () => {
          return axios.get(`${BASE_URL}/get-timechart-data`, { params }).then((res) => res.data);
        },
        enabled: options.enabled ?? true,
        retry: options.retry ?? 1,
      });
    },
  },
});

export const {
  customerServiceList,
  customerServiceCreate,
  customerServiceGetById,
  customerServiceGetBySubId,
  customerServiceGetBmrByIds,
  customerServiceUpdate,
  customerServiceUpdateSpecific,
  customerServiceDownload,
  customerServiceDelete,
  customerServiceCount,
  customerServiceCreateReport,
  customerServiceGetTimechartData
} = generateHookExports(customerService, "customerService");
